
import { Component, Vue } from "vue-property-decorator";
import HeaderService from "@/services/HeaderService";
import HeaderFooter from "@/models/Header_Footer/HeaderFooter";
import { AxiosResponse } from "axios";
import GlobalConfig from "@/GlobalConfig";


@Component({})
export default class FooterComponent extends Vue {
    public footer = new HeaderFooter();
    public footerService = new HeaderService();
	public umbracoUrl: string = GlobalConfig.UMBRACO_BASE_URL;

    async mounted() {
        await this.getHeaderData();
    }
    async getHeaderData() {
        this.footerService
            .get("MasterService/_umbracoMaster")
            .then((resp: AxiosResponse<HeaderFooter>) => {
                this.footer = resp.data;
            });
    }
}
